<template>
  <v-btn class="quick-action"
         height="auto"
         text
         v-bind:href="href"
         v-bind:target="target"
         v-on:click="$emit('click')">
    <span class="align-center d-flex flex-column py-2">
      <v-avatar color="accent"
                size="44">
        <v-icon dark>{{ icon }}</v-icon>
      </v-avatar>
      <span class="caption mt-1">{{ label }}</span>
    </span>
  </v-btn>
</template>

<script>
  export default {
    name: 'QuickAction',
    props: {
      href: String,
      icon: String,
      label: String,
      target: String
    }
  }
</script>

<style scoped>
  .quick-action {
    flex: 1 1 0;
    letter-spacing: normal;
    min-width: 72px !important;
    text-transform: none;
  }
</style>
